import React from 'react';
import { ProcurementDiscrepancy } from '@/types/database/procurement-discrepancies';
import DiscrepancyCard from './DiscrepancyCard';
import { Skeleton } from '@/components/ui/skeleton';

interface DiscrepancyListProps {
  discrepancies: ProcurementDiscrepancy[];
  isLoading?: boolean;
  onResolve?: (id: string) => void;
  onMarkReviewed?: (id: string) => void;
  showActions?: boolean;
  emptyMessage?: string;
}

const DiscrepancyList: React.FC<DiscrepancyListProps> = ({
  discrepancies,
  isLoading = false,
  onResolve,
  onMarkReviewed,
  showActions = true,
  emptyMessage = 'No discrepancies found',
}) => {
  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-40 w-full" />
        ))}
      </div>
    );
  }

  if (discrepancies.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {discrepancies.map((discrepancy) => (
        <DiscrepancyCard
          key={discrepancy.id}
          discrepancy={discrepancy}
          onResolve={onResolve}
          onMarkReviewed={onMarkReviewed}
          showActions={showActions}
        />
      ))}
    </div>
  );
};

export default DiscrepancyList;
